import { render, staticRenderFns } from "./Kontaktujte.vue?vue&type=template&id=1a25770f"
import script from "./Kontaktujte.vue?vue&type=script&lang=js"
export * from "./Kontaktujte.vue?vue&type=script&lang=js"
import style0 from "./Kontaktujte.vue?vue&type=style&index=0&id=1a25770f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports